export default "https://cdn-static.gokick.com/assets/b4422e726e3b42ca3d48f0d34192932f5b3fbcfa/images/sleep-green-apple.f7a444510e3da94f2e4fec3a465032b1.png";